import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Loading } from "@/pages/Other/Loading";

function CompaniesHiring() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

 

  useEffect(() => {
    async function fetchBusinessData() {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/businessdata`);
        const events = JSON.parse(response.data);
        setData(events);
      }
      catch (error) {
        console.error("Error fetching business data:", error);
      }
    }
    fetchBusinessData();
  }, []);

  if (!data) {
    return <div className="text-center text-gray-500 text-lg"><Loading/></div>;
  }

  return (
    <div className="max-w-7xl mx-auto py-10 px-4">
      <h2 className="text-3xl font-bold text-gray-900 mb-6">Companies Hiring</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 mt-8 items-center justify-center">
        {data?.companies?.map((company) => (
          <div key={company.id} className="flex justify-center">
            <img
              src={`${process.env.REACT_APP_COURSE_API_BASEURL}${company.logo}` || "/placeholder.svg"}
              alt={t(company.name)}
              className="w-24 h-16 object-contain  transition-transform duration-300 hover:scale-105"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default CompaniesHiring;
